export const hasAncestor = (el: HTMLElement, search: HTMLElement): boolean => {
  if (el === search) {
    return true
  }

  if (!el.parentElement) {
    return false
  }

  return hasAncestor(el.parentElement, search)
}

export const getHeight = (
  el: HTMLElement,
  withMargin: boolean = false
): number => {
  let margin = 0

  if (withMargin) {
    const style = window.getComputedStyle(el)
    margin = parseInt(`${style.marginBottom}`) + parseInt(`${style.marginTop}`)
  }

  return el.offsetHeight + margin
}

export const getWidth = (
  el: HTMLElement,
  withMargin: boolean = false
): number => {
  let margin = 0

  if (withMargin) {
    const style = window.getComputedStyle(el)
    margin = parseInt(`${style.marginLeft}`) + parseInt(`${style.marginRight}`)
  }

  return el.offsetWidth + margin
}
